import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Icon, Label, Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationMenuItem extends React.Component {
  render() {
    const {
      children,
      item,
      push,
      sidebar,
      customProps = {},
      hideSidebar,
    } = this.props

    const badgeContent = customProps.badge === 'hide' ? false : item.badge

    return (
      <Menu.Item
        {...customProps}
        {...{
          active: item.active,
          fitted: !sidebar,
          href: item.path,
          name: item.name,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
        color="black" /* customProps.color is intended for the icon below, thus overwrite hack here */
      >
        {badgeContent ? (
          <Label color="red" className="badge">
            {badgeContent}
          </Label>
        ) : (
          ''
        )}
        <Icon
          color={customProps.color}
          name={customProps.icon ? customProps.icon : item.icon}
          size="large"
        />
        {children ? children : item.content}
      </Menu.Item>
    )
  }
}

NavigationMenuItem = connect(mapStateToProps, mapDispatchToProps)(
  NavigationMenuItem
)
export default NavigationMenuItem



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationMenuItem.jsx